export default __webpack_public_path__ + "static/media/detail_big_13_3.3fc917b3.jpg";